import Text from './Text';

export default class Tooltip extends PIXI.Container {
	constructor() {
		super();

		const tooltipArrow = new PIXI.Sprite(P3.assets.texture('tooltip_arrow'));

		tooltipArrow.anchor.set(0, 0.5);
		tooltipArrow.position.set(15, 0);
		this.addChild(tooltipArrow);

		this._panel = new PIXI.NineSlicePlane(P3.assets.texture('tooltip_tile_information_9slice'), 40, 40, 40, 40);
		this._panel.position.set(25, -this._panel.height * 0.5 + 5);
		this.addChild(this._panel);

		this._colourOverlay = new PIXI.Sprite(P3.assets.texture('tooltip_tile_information_9slice_1'));
		this._panel.addChild(this._colourOverlay);

		this._labelHolder = new PIXI.Container();
		this.addChild(this._labelHolder);

		this._riskCategoryLabel = new Text('0', { font: '32px', fontWeight: 'bold', align: 'left', tint: 0xFFFFFF });
		this._riskCategoryLabel.position.set(50, 15);
		this._labelHolder.addChild(this._riskCategoryLabel);

		this._nameLabel = new Text('', { font: '28px', fontWeight: 'bold', align: 'left', tint: 0x0 });
		this._nameLabel.position.set(90, 0);
		this._labelHolder.addChild(this._nameLabel);

		this._riskIcon = new PIXI.Sprite(P3.assets.texture('icon_warning'));
		this._riskIcon.anchor.set(0, 0.5);
		this._riskIcon.scale.set(0.7);
		this._riskIcon.position.set(90, 45);
		this._labelHolder.addChild(this._riskIcon);

		this._riskLabel = new Text('0%', { font: '28px', align: 'left', tint: 0x0 });
		this._riskLabel.anchor.set(0, 0.5);
		this._riskLabel.position.set(this._riskIcon.x + this._riskIcon.width + 5, this._riskIcon.y);
		this._labelHolder.addChild(this._riskLabel);

		this._popIcon = new PIXI.Sprite(P3.assets.texture('icon_contextual_develop'));
		this._popIcon.anchor.set(0, 0.5);
		this._popIcon.scale.set(0.7);
		this._popIcon.position.set(this._riskLabel.x + this._riskLabel.width + 30, this._riskIcon.y);
		this._labelHolder.addChild(this._popIcon);

		this._popLabel = new Text('0', { font: '28px', align: 'left', tint: 0x0 });
		this._popLabel.anchor.set(0, 0.5);
		this._popLabel.position.set(this._popIcon.x + this._popIcon.width + 5, this._riskIcon.y);
		this._labelHolder.addChild(this._popLabel);

		this._labelHolder.y = -this._labelHolder.height * 0.5;
	}

	set(name, population, risk, riskCategory) {
		this._nameLabel.text = name;
		this._popLabel.text = population;
		this._riskLabel.text = `${100 - risk}%`;
		this._riskCategoryLabel.text = parseInt(riskCategory) + 1;
		this._colourOverlay.texture = P3.assets.texture(`tooltip_tile_information_9slice_${parseInt(riskCategory) + 1}`);
		this.resize();
	}

	resize() {
		this._panel.width = Math.max((this._nameLabel.x + this._nameLabel.width), (this._popLabel.x + this._popLabel.width));
	}
}
